module.exports = __webpack_public_path__ + "media/images/app/register/fb-icon-white-c6b59bfbed1393891d88cbfe503bab98.svg";